import { useQuery } from "@tanstack/react-query";
import { api } from "./api";
import type { ResourceSchema } from "./types";

export interface SchemaResponse {
  resources: ResourceSchema[];
  features: { geocoding: boolean };
}

/** The registry, fetched once. Every table screen and the nav are built from it. */
export function useSchema() {
  return useQuery({
    queryKey: ["schema"],
    queryFn: () => api.get<SchemaResponse>("/superadmin/resources"),
    staleTime: Infinity,
  });
}

export function useResource(key: string | undefined) {
  const { data, isLoading } = useSchema();
  const resource = data?.resources.find((r) => r.key === key);
  return { resource, isLoading, features: data?.features };
}
